import axios, { AxiosRequestConfig } from 'axios';
import { clone } from 'lodash';

// Types and constants
import { IBaseApi } from '../shared/types';
import { getAccessToken } from '../utils/auth';

axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
    const token = await getAccessToken();
    
    const newConfig = clone(config);
    if (newConfig.headers) {
        newConfig.headers.Authorization = `Bearer ${token}`;
    }

    return newConfig;
}, (err) => {
        console.log({ err });
    });

export const baseApi: IBaseApi = {
    get: async<T>(url: string, customHeaders?: any): Promise<T> => {
        const config = {
            withCredential: true,
            headers: {
                ...customHeaders
            }
        };

        const response = await axios.get(url, config);
        return response.data;
    },
    post: async<T, R>(url: string, body: any, customHeaders?: any): Promise<R> => {
        const config = {
            withCredential: true,
            headers: {
                ...customHeaders
            }
        };

        const response = await axios.post(url, body, config);
        return response.data;
    },
    put: async<T>(url: string, body: T, customHeaders?: any): Promise<T> => {
        const config = {
            withCredential: true,
            headers: {
                ...customHeaders
            }
        };

        const response = await axios.put(url, body, config);
        return response.data;
    },
    delete: async (url: string, customHeaders?: any): Promise<void> => {
        const config = {
            withCredential: true,
            headers: {
                ...customHeaders
            }
        };

        await axios.delete(url, config);
    },
};
